import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TransferRecipientService } from '../../../services/transfer-recipient.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AiAgentResponse } from '../../../models/responses/ai-agent-response';
import { AiConfigurationPageEventsService } from '../../../events/ai-configuration-page-events.service';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TransferRecipientResponse } from '../../../models/responses/transfer-recipient-response';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatDivider } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { AsyncPipe, NgIf } from '@angular/common';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-add-edit-transfer-dialog',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatDialogModule,
    MatDivider,
    MatIconModule,
    NgIf,
    MatAutocompleteModule,
    AsyncPipe,
    MatProgressSpinnerModule
  ],
  templateUrl: './add-edit-transfer-dialog.component.html',
  styleUrl: './add-edit-transfer-dialog.component.scss'
})
export class AddEditTransferDialogComponent {
  transferForm!: FormGroup;
  isEditing: boolean = false;
  isLoading: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<AddEditTransferDialogComponent>,
    private transferRecipientService: TransferRecipientService,
    private snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: { tranferRecipient: TransferRecipientResponse, aiAgent: AiAgentResponse },
    private aiConfigurationPageEventsService: AiConfigurationPageEventsService
  ) { }

  ngOnInit() {
    this.initTransferForm();
  }

  initTransferForm() {
    if (this.data.tranferRecipient)
      this.isEditing = true;

    this.transferForm = this.formBuilder.group({
      id: [this.data.tranferRecipient ? this.data.tranferRecipient.id : undefined],
      name: [this.data.tranferRecipient ? this.data.tranferRecipient.name : '', Validators.required],
      phoneNumber: [this.data.tranferRecipient ? this.data.tranferRecipient.phoneNumber : '', Validators.required],
      businessId: [this.data.aiAgent.id, Validators.required],
    });
  }

  onSubmitForm() {
    if (this.transferForm.valid) {
      this.isLoading = true;
      const formValues = this.transferForm.value;
      const transferRecipients: TransferRecipientResponse[] = [];
      const id: number = parseInt(formValues['id']);
      transferRecipients.push({
        id: isNaN(id) ? undefined : id,
        name: formValues['name'],
        phoneNumber: formValues['phoneNumber'],
        aiAgentId: formValues['businessId'],
      });

      if (this.isEditing)
        this.batchEditRecipients(transferRecipients);
      else
        this.batchCreateRecipients(transferRecipients);
    }
  }

  batchCreateRecipients(transferRecipients: TransferRecipientResponse[]) {
    this.transferRecipientService.batchCreate(transferRecipients).subscribe({
      next: () => {
        this.isLoading = false;
        this.snackBar.open('Recipient added successfully', 'Close', { duration: 5000 });
        this.aiConfigurationPageEventsService.onRefreshAiAgentEvent.emit();
        this.dialogRef.close();
      },
      error: () => {
        this.isLoading = false;
        alert('Error from server contact support');
      }
    });
  }

  batchEditRecipients(transferRecipients: TransferRecipientResponse[]) {
    this.transferRecipientService.batchUpdate(transferRecipients).subscribe({
      next: () => {
        this.isLoading = false;
        this.snackBar.open('Recipient saved successfully', 'Close', { duration: 5000 });
        this.aiConfigurationPageEventsService.onRefreshAiAgentEvent.emit();
        this.dialogRef.close();
      },
      error: () => {
        this.isLoading = false;
        alert('Error from server contact support');
      }
    });
  }
}
